import { render, staticRenderFns } from "./CortaCorriente.vue?vue&type=template&id=63bc8f62&scoped=true&"
import script from "./CortaCorriente.vue?vue&type=script&lang=ts&"
export * from "./CortaCorriente.vue?vue&type=script&lang=ts&"
import style0 from "./CortaCorriente.vue?vue&type=style&index=0&id=63bc8f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc8f62",
  null
  
)

export default component.exports